import { fallbackProductImage } from './const';

export interface ProductImage {
  readonly url: string;
  readonly width: number;
  readonly height: number;
}

export interface Asset {
  readonly type: string;
  readonly url: string;
  readonly width?: number;
  readonly height?: number;
}

export const getProductImageOrFallback = (
  source: ProductImage | ReadonlyArray<ProductImage> | null,
  assets: ReadonlyArray<Asset> | null = null
): ProductImage => {
  let productImage;

  const testRatingImage = assets?.find((asset) => asset.type === 'TUV');
  if (testRatingImage) {
    productImage = {
      url: testRatingImage.url,
      width: testRatingImage.width ?? 0,
      height: testRatingImage.height ?? 0
    };
  } else if (source === null) {
    productImage = fallbackProductImage;
  } else if (Array.isArray(source)) {
    productImage = source[0];
  } else {
    productImage = source;
  }

  return productImage;
};
